import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import { useContext, useEffect } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { useSetRecoilState } from 'recoil';

import { Layout } from 'Components/Layout';
import { IProduct } from 'Interfaces/Product';
import { ColorModeContext } from 'lib/contexts';
import { productsState } from 'lib/recoil/atoms';
import { CollectionsPage } from 'Pages/Collections';
import { MarketplacePage } from 'Pages/Marketplace';
import { NftProductPage } from 'Pages/NftProduct';

const products: IProduct[] = [
	{
		id: 1,
		collectionId: 1,
		name: 'Tunnel Vision',
		price: 1,
		url: 'https://collection-taupe.vercel.app/Tunnel.html'
	},
	{
		id: 2,
		collectionId: 1,
		name: 'Hueco Mundo',
		price: 2,
		url: 'https://collection-taupe.vercel.app/HuecoMundo.html'
	},
	{
		id: 3,
		collectionId: 1,
		name: 'From Beyond',
		price: 1,
		url: 'https://collection-taupe.vercel.app/beyond.html'
	},
	{
		id: 4,
		collectionId: 1,
		name: 'Yarn Cat Start',
		price: 192,
		url: 'https://collection-taupe.vercel.app/Yarn.html'
	},
	{
		id: 5,
		collectionId: 1,
		name: 'Rings',
		price: 1,
		url: 'https://collection-taupe.vercel.app/rings.html'
	},
	{
		id: 6,
		collectionId: 1,
		name: 'Hueco Mundo 2',
		price: 3,
		url: 'https://collection-taupe.vercel.app/hm2.html'
	},
	{
		id: 7,
		collectionId: 1,
		name: 'Holomatron',
		price: 1,
		url: 'https://collection-taupe.vercel.app/holomatron.html'
	},
	
	{
		id: 8,
		collectionId: 1,
		name: 'Incipit 2',
		price: 5,
		url: 'https://collection-taupe.vercel.app/incipit2.html'
	},
	{
		id: 9,
		collectionId: 1,
		name: 'Incipit 1',
		price: 5,
		url: 'https://collection-taupe.vercel.app/incipit1.html'
	},
	{
		id: 10,
		collectionId: 1,
		name: 'Incipit 4',
		price: 5,
		url: 'https://collection-taupe.vercel.app/incipit4.html'
	},
	{
		id: 11,
		collectionId: 1,
		name: 'In Phase',
		price: 1,
		url: 'https://collection-taupe.vercel.app/inphase.html'
	},
	{
		id: 12,
		collectionId: 1,
		name: 'Bloom',
		price: 1,
		url: 'https://collection-taupe.vercel.app/bloom.html'
	},
	{
		id: 13,
		collectionId: 1,
		name: 'Gravitron',
		price: 1,
		url: 'https://collection-taupe.vercel.app/gravitron.html'
	},
	{
		id: 14,
		collectionId: 1,
		name: 'Lost Kingdom',
		price: 1,
		url: 'https://collection-taupe.vercel.app/lost.html'
	},
	{
		id: 15,
		collectionId: 1,
		name: 'Sturm',
		price: 1,
		url: 'https://collection-taupe.vercel.app/sturm.html'
	},
    {
		id: 16,
		collectionId: 1,
		name: 'And Scene',
		price: 1,
		url: 'https://lhq4n-3yaaa-aaaai-qaniq-cai.raw.ic0.app/nft/610'
	},
    {
		id: 17,
		collectionId: 1,
		name: 'Squared',
		price: 1,
		url: 'https://lhq4n-3yaaa-aaaai-qaniq-cai.raw.ic0.app/nft/592'
	},
    
    {
		id: 18,
		collectionId: 1,
		name: 'Cradle',
		price: 1,
		url: 'https://lhq4n-3yaaa-aaaai-qaniq-cai.raw.ic0.app/nft/594'
	},
    {
		id: 19,
		collectionId: 1,
		name: 'Road to Nowhere',
		price: 1,
		url: 'https://collection-taupe.vercel.app/road.html'
	},
    {
		id: 20,
		collectionId: 1,
		name: 'Voices',
		price: 1,
		url: 'https://collection-taupe.vercel.app/voices.html'
	},

    
    {
		id: 22,
		collectionId: 1,
		name: 'Zombie Mayhem',
		price: 1,
		url: 'https://fuq3k-qyaaa-aaaak-qab2a-cai.raw.ic0.app/nft/114'
	},

    {
		id: 1,
		collectionId: 4,
		name: 'TM Shooter DX',
		price: 5,
		url: 'https://lhq4n-3yaaa-aaaai-qaniq-cai.raw.ic0.app/nft/648'
	},
    {
		id: 2,
		collectionId: 4,
		name: 'Copycat',
		price: 1,
		url: 'https://lhq4n-3yaaa-aaaai-qaniq-cai.raw.ic0.app/nft/588'
	},
];


function App() {
	const { theme } = useContext(ColorModeContext);
	const setProducts = useSetRecoilState(productsState);

	useEffect(() => {
		setProducts(products);

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<ThemeProvider theme={theme}>
			<CssBaseline enableColorScheme />
			<BrowserRouter>
				<Routes>
					<Route path='/' element={<Layout />}>
						<Route index element={<MarketplacePage />} />
						<Route path=':nftId' element={<NftProductPage />} />
						<Route path='collections' element={<CollectionsPage />} />
						<Route path='*' element={<>There's nothing here!</>} />
					</Route>
				</Routes>
			</BrowserRouter>
		</ThemeProvider>
	);
}

export default App;
